import { Component, OnInit } from '@angular/core';
import { language} from '../../language/vn';
@Component({
  templateUrl: 'mainlist.component.html'
})
export class EgovMainListComponent  {
  public language = language;



}
